import { gql } from "@apollo/client";

export const UPDATE_TERMINAL_CONFIG_FROM_CALIBRATION = gql`
  mutation UpdateConfigFromCalibration($domain: String!, $terminalid: Int!, $gramPerRotation: Int!) {
    terminal {
      updateConfigFromCalibration(domain: $domain, terminalid: $terminalid, gramPerRotation: $gramPerRotation) {
        code
        success
        message
      }
    }
  }
`

export interface UpdateTerminalConfigFromCalibration {
  domain: string
  terminalid: number
  gramPerRotation: number
}

interface UpdateTerminalFromCalibration {
  code: String
  success: Boolean
  message: string
}

export interface UpdateTerminalFromCalibrationResponse {
  terminal: {
    updateConfigFromCalibration: UpdateTerminalFromCalibration
  }
}